import React from "react";
import PropTypes from "prop-types";
import {
  Radar,
  RadarChart as RCRadarChart,
  PolarGrid,
  ResponsiveContainer,
  PolarAngleAxis,
  Tooltip,
} from "recharts";

export const RadarChart = ({
  data,
  gridProps,
  radarProps,
  angleAxisProps,
  tooltipContent,
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RCRadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
        {gridProps && <PolarGrid stroke="#fff" opacity="0.5" {...gridProps} />}

        {angleAxisProps && <PolarAngleAxis {...angleAxisProps} />}

        {tooltipContent && <Tooltip content={tooltipContent} />}

        <Radar
          stroke="#0A7EFF"
          fill="#0A7EFF"
          fillOpacity={0.2}
          strokeWidth={2}
          {...radarProps}
        />
      </RCRadarChart>
    </ResponsiveContainer>
  );
};

RadarChart.propTypes = {
  data: PropTypes.array,
  gridProps: PropTypes.elementType,
  radarProps: PropTypes.elementType,
  angleAxisProps: PropTypes.elementType,
  tooltipContent: PropTypes.elementType,
};

RadarChart.defaultProps = {
  data: [],
};
